export default "__VITE_ASSET__O20ZjPvD__"